import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=12913e29&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/shared/Header/HeaderStylePublic.css?vue&type=style&index=0&id=12913e29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12913e29",
  null
  
)

export default component.exports